// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentReviewEntity from './entities/document-review.json';
import documentReviewMenu from '../pages/document-review/menu.json';
import documentReviewFullForm from '../pages/document-review/forms/full.json';
import documentReviewContextForm from '../pages/document-review/forms/context.json';
import documentReviewMiniForm from '../pages/document-review/forms/mini.json';
import documentReviewLookupForm from '../pages/document-review/forms/lookup.json';
import documentReviewTableView from '../pages/document-review/views/table.json';
import documentReviewCardsView from '../pages/document-review/views/cards.json';
import documentReviewCalendarView from '../pages/document-review/views/calendar.json';
import documentReviewDashboardView from '../pages/document-review/views/dashboard.json';

/** Тип запису «Погодження документа» зі сторінками пакета: меню, форми та подання з pages/document-review/. */
export const documentReviewDefinition: IRecordTypeDefinition = {
  ...documentReviewEntity,
  views: assembleViewSet({
      table: documentReviewTableView,
      cards: documentReviewCardsView,
      calendar: documentReviewCalendarView,
      dashboard: documentReviewDashboardView,
  }),
  form: documentReviewFullForm,
  forms: { full: documentReviewFullForm, context: documentReviewContextForm, mini: documentReviewMiniForm, lookup: documentReviewLookupForm },
  menu: documentReviewMenu,
} as IRecordTypeDefinition;
